import { AfterViewInit, ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { ContactCardWidgetComponent } from '../contact-card-widget/contact-card-widget.component';

@Component({
  selector: 'app-formly-contact-card-widget',
  templateUrl: './formly-contact-card-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ContactCardWidgetComponent
  ]
})
export class FormlyContactCardWidgetComponent extends FieldType implements AfterViewInit {

  //cdRef = inject(ChangeDetectorRef);

  @ViewChild('contactCardWidget')
  contactCardWidget: ContactCardWidgetComponent;

  constructor() {
    super();
  }

  ngAfterViewInit(): void {
    this.form.valueChanges.subscribe((value) => {
      this.contactCardWidget?.update();
    });
  }


}
